// extracted by mini-css-extract-plugin
export default {"container":"SharedLayout_container__SSFEK","nav":"SharedLayout_nav__+W88p","header":"SharedLayout_header__HMjkG","nav_active":"SharedLayout_nav_active__vrGtg"};